import { parseOptionSymbol } from './parseOptionSymbol';

export class TradierSymbolParser {
  constructor(public symbol: string) {}

  public get underlyingSymbol() {
    if (this.symbol.length < 7) {
      return this.symbol;
    }

    return this.parsed?.underlyingSymbol;
  }

  public get parsed() {
    return parseOptionSymbol(this.symbol);
  }
}
